import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import OutlinedInput from "@mui/material/OutlinedInput"
import {
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField
} from "@mui/material"
import Checkbox from "@mui/material/Checkbox"
import Autocomplete from "@mui/material/Autocomplete"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import BackButton from "../../components/mui/BackButton"
import Modal from "react-bootstrap/Modal"
import TableMui from "../../components/mui/TableMui"
import apiClient from "../../api/apiClient"
import { useDispatch } from "react-redux"
import { showModal } from "../../redux/modalSlice"
import Paper from "@mui/material/Paper"
import InputBase from "@mui/material/InputBase"
import Divider from "@mui/material/Divider"
import IconButton from "@mui/material/IconButton"
import MenuIcon from "@mui/icons-material/Menu"
import SearchIcon from "@mui/icons-material/Search"
import DirectionsIcon from "@mui/icons-material/Directions"
import { toast } from "react-toastify"
import { Helmet } from "react-helmet"
import CategoryManager from "./CategoriesManage"
import HighLowSelect from "../../components/HighLowSelect"
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const getName = value => {
  if (!value) return ""
  if (typeof value === "string") return value
  return value.name || value._id?.name || ""
}

const textIncludes = (value, search = "") =>
  getName(value).toLowerCase().includes((search || "").toLowerCase())

const joinNames = values => (values || []).map(getName).filter(Boolean).join(", ")

const reportActionIconButtonSx = {
  alignItems: "center",
  backgroundColor: "#fff",
  borderRadius: "50%",
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  display: "flex",
  height: 36,
  justifyContent: "center",
  padding: "8px",
  width: 36,
  "&:hover": {
    backgroundColor: "#fff"
  }
}

function ReportSettingsAction({ type, title, onClick }) {
  const isDelete = type === "delete"
  const Icon = isDelete ? DeleteIcon : EditIcon
  const [showConfirm, setShowConfirm] = useState(false)

  const handleClick = () => {
    if (isDelete) {
      setShowConfirm(true)
      return
    }

    onClick?.()
  }

  const handleConfirm = async () => {
    await onClick?.()
    setShowConfirm(false)
  }

  return (
    <>
      <IconButton
        aria-label={title}
        onClick={handleClick}
        sx={reportActionIconButtonSx}
        title={title}
      >
        <Icon sx={{ color: isDelete ? "#d32f2f" : "#1976d2", fontSize: 20 }} />
      </IconButton>

      {isDelete && (
        <Modal
          show={showConfirm}
          onHide={() => setShowConfirm(false)}
          size="sm"
          aria-labelledby="report-delete-confirmation"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="report-delete-confirmation" className="text-center w-100">
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: "#3E4755",
                  borderRadius: "50%",
                  display: "inline-flex",
                  height: 40,
                  justifyContent: "center",
                  p: "4px",
                  width: 40
                }}
              >
                <DeleteIcon style={{ fontSize: "18px", color: "white" }} />
              </Box>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4 className="text-center">Delete item</h4>
            <p className="text-center">
              Are you sure you want to delete <br /> this item?
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex flex-column">
            <Button
              onClick={handleConfirm}
              sx={{ borderRadius: "20px" }}
              fullWidth
              variant="contained"
              className="btn_bg_secondery"
            >
              Yes
            </Button>
            <Button
              sx={{ borderRadius: "20px" }}
              onClick={() => setShowConfirm(false)}
              fullWidth
              variant="contained"
              className="mt-2 btn_bg_secondery"
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  }
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

export const AdminReports = () => {
  const [value, setValue] = useState(0)
  const dispatch = useDispatch()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 2, md: 3 } }}>
      <Helmet>
        <title>Reports Data</title>
      </Helmet>
      <Box sx={{ mb: 3 }}>
        <h3 className="mb-1">Report Settings</h3>
        <p className="mb-0 text-muted">Manage report categories, items, rules, and products.</p>
      </Box>
      <Box
        sx={{
          backgroundColor: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 3,
          boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
          overflow: "hidden",
          width: "100%"
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2, pt: 2 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="report settings tabs"
            sx={{
              minHeight: 44,
              "& .MuiTab-root": {
                borderRadius: "8px 8px 0 0",
                // fontWeight: 600,
                minHeight: 44,
                textTransform: "none"
              },
              "& .MuiTabs-indicator": { display: "none" }
            }}>
            <Tab
              style={{
                color: value === 0 ? "white" : "black",
                backgroundColor: value === 0 ? "#3E4755" : "transparent"
              }}
              label="Add Category"
              {...a11yProps(0)}
            />
            <Tab
              style={{
                color: value === 1 ? "white" : "black",
                backgroundColor: value === 1 ? "#3E4755" : "transparent"
              }}
              label="Add Item"
              {...a11yProps(1)}
            />
            <Tab
              style={{
                color: value === 2 ? "white" : "black",
                backgroundColor: value === 2 ? "#3E4755" : "transparent"
              }}
              label="If Then"
              {...a11yProps(2)}
            />
            <Tab
              style={{
                color: value === 3 ? "white" : "black",
                backgroundColor: value === 3 ? "#3E4755" : "transparent"
              }}
              label="Product"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <CategoryTab />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <ItemTab />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <IfThenTab />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={3}>
          <ProductTab />
        </CustomTabPanel>
      </Box>
    </Box>
  )
}

// Category Tab Component
const CategoryTab = () => {
  const [categoryData, setCategoryData] = useState()
  const [categoryFilterData, setCategoryFilterData] = useState()
  const [search, setSearch] = useState()
  const [categoryEdit, setCategoryEdit] = useState()
  const [category, setCategory] = useState(false)
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch()

  const fetchData = async () => {
    setLoad(true)
    const result = await apiClient.get("/report/category?sort=name")
    if (!result.ok) return console.log("error")
    setCategoryData(result.data.results)
    setCategoryFilterData(result.data.results)
    setLoad(false)
  }

  const remove = async id => {
    const result = await apiClient.delete(`/report/category/${id}`)
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    fetchData()
  }

  const filterData = value => {
    const filteredData = categoryFilterData.filter(item => {
      return item.name.toLowerCase().includes(value.toLowerCase())
    })
    setCategoryData(filteredData)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Box>
      <Grid container>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search"
              inputProps={{ "aria-label": "search " }}
              onKeyUp={e => e.key === "Enter" && filterData(search)}
            />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon onClick={() => filterData(search)} />
            </IconButton>
          </Paper>
        </Grid>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Button
            className="btn btn_bg_ter"
            variant="contained"
            onClick={() => {
              setCategoryEdit(false)
              setCategory(true)
            }}>
            Add Category
          </Button>
        </Grid>
        {!load ? (
          <TableMui
            styleTableContainer={{ height: "70vh" }}
            styleTableTh={{
              color: "white",
              backgroundColor: "#3E4755",
              fontWeight: "bold",
              whiteSpace: "nowrap"
            }}
            th={{
              name: "Category",
              actions: "Action"
            }}
            td={categoryData}
            customFields={[
              {
                name: "actions",
                data: (value, item) => (
                  <Box className="d-flex  gap-3">
                    <ReportSettingsAction
                      title="Edit"
                      type="edit"
                      onClick={() => {
                        setCategoryEdit(item)
                        setCategory(true)
                      }}
                    />
                    <ReportSettingsAction
                      title="Delete"
                      type="delete"
                      onClick={() => {
                        remove(item._id)
                      }}
                    />
                  </Box>
                )
              }
            ]}
          />
        ) : (
          <div className=" w-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </div>
        )}

        {category && (
          <Category
            categoryEdit={categoryEdit}
            fetchData={fetchData}
            show={category}
            onHide={() => setCategory(false)}
          />
        )}
      </Grid>
      <Box sx={{ paddingTop: 20 }}>
        <CategoryManager />
      </Box>
      <Box sx={{ paddingTop: 20 }}>
        <CategoryManager type="UI" />
      </Box>
    </Box>
  )
}

// Item Tab Component
const ItemTab = () => {
  const [itemData, setItemData] = useState()
  const [itemFilterData, setItemFilterData] = useState()
  const [itemDataEdit, setItemDataEdit] = useState()
  const [search, setSearch] = useState()
  const [keyword, setKeyword] = useState("item")
  const [item, setItem] = useState(false)
  const [load, setLoad] = useState(false)
  const [categoryData, setCategoryData] = useState()
  const dispatch = useDispatch()
  const fetchItemData = async () => {
    setLoad(true)
    const result = await apiClient.get("/report/item?limit=100000000&sort=name")
    if (!result.ok) return console.log("error")
    setLoad(false)
    setItemData(result.data.results)
    setItemFilterData(result.data.results)
  }

  const fetchData = async () => {
    const result = await apiClient.get("/report/category?sort=name")
    if (!result.ok) return console.log("error")
    setCategoryData(result.data.results)
  }

  const removeItem = async id => {
    const result = await apiClient.delete(`/report/item/${id}`)
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    fetchItemData()
  }

  const filterItem = value => {
    if (keyword === "item") {
      const filteredData = itemFilterData.filter(item => {
        return textIncludes(item, value)
      })
      setItemData(filteredData)
    } else if (keyword === "category") {
      const filteredData = itemFilterData.filter(item => {
        return textIncludes(item.category, value)
      })
      setItemData(filteredData)
    }
  }

  useEffect(() => {
    fetchItemData()
    fetchData()
  }, [])

  return (
    <Grid container className=" d-flex justify-content-center align-items-center">
      <Grid container>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search"
              inputProps={{ "aria-label": "search " }}
              onKeyUp={e => e.key === "Enter" && filterItem(search)}
            />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon onClick={() => filterItem(search)} />
            </IconButton>
          </Paper>
          <FormControl className="">
            <InputLabel id="demo-simple-select-label">Select</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={keyword}
              label="Select"
              onChange={e => setKeyword(e.target.value)}>
              <MenuItem value={"item"}>Item</MenuItem>
              <MenuItem value={"category"}>Category</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Button
            className="btn btn_bg_ter"
            variant="contained"
            onClick={() => {
              setItemDataEdit(false)
              setItem(true)
            }}>
            Add Item
          </Button>
        </Grid>
        {!load ? (
          <TableMui
            styleTableContainer={{ height: "70vh" }}
            styleTableTh={{
              color: "white",
              backgroundColor: "#3E4755",
              fontWeight: "bold",
              whiteSpace: "nowrap"
            }}
            th={{
              name: "Item",
              "category.name": "Category",
              actions: "Action"
            }}
            td={itemData}
            customFields={[
              {
                name: "category.name",
                data: (value, item) => getName(item.category)
              },
              {
                name: "actions",
                data: (value, item) => (
                  <Box className="d-flex  gap-3">
                    <ReportSettingsAction
                      title="Edit"
                      type="edit"
                      onClick={() => {
                        setItemDataEdit(item)
                        setItem(true)
                      }}
                    />
                    <ReportSettingsAction
                      title="Delete"
                      type="delete"
                      onClick={() => removeItem(item._id)}
                    />
                  </Box>
                )
              }
            ]}
          />
        ) : (
          <div className="w-100 d-flex justify-content-center slign-items-center">
            <CircularProgress />
          </div>
        )}
      </Grid>

      {item && (
        <Item
          fetchItemData={fetchItemData}
          itemDataEdit={itemDataEdit}
          categoryData={categoryData}
          show={item}
          onHide={() => setItem(false)}
        />
      )}
    </Grid>
  )
}

// Main IfThenTab Component
const IfThenTab = () => {
  const [itemData, setItemData] = useState([])
  const [productData, setProductData] = useState([])
  const [load, setLoad] = useState(false)

  const fetchProduct = async () => {
    setLoad(true)
    const result = await apiClient.get("/report/product")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    setProductData(result.data.results)
    setLoad(false)
  }

  const fetchItemData = async () => {
    setLoad(true)
    const result = await apiClient.get("/report/item?limit=100000000&sort=name")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    setItemData(result.data.results)
    setLoad(false)
  }

  useEffect(() => {
    fetchProduct()
    fetchItemData()
  }, [])

  return (
    <Grid className="">
      <IfThenItemsSection itemData={itemData} setLoad={setLoad} />
      <IfThenIntolPetSection itemData={itemData} setLoad={setLoad} />
      <IfThenProductsSection itemData={itemData} productData={productData} setLoad={setLoad} />
      <IfThenPetTypeProductsSection
        itemData={itemData}
        productData={productData}
        setLoad={setLoad}
      />
      <EnergeticImbalanceSection productData={productData} setLoad={setLoad} />
      <EnergeticImbalanceRefIntolSection itemData={itemData} setLoad={setLoad} />
    </Grid>
  )
}
// IfThenItemsSection Component
const IfThenItemsSection = ({ itemData, setLoad }) => {
  const [ifthenData, setIfthenData] = useState([])
  const [ifFilterData, setIfFilterData] = useState([])
  const [search, setSearch] = useState("")
  const [ifthenEdit, setIfthenEdit] = useState(null)
  const [ifthenModal, setIfthenModal] = useState(false)
  const [itemDataEdit, setItemDataEdit] = useState(false)
  const dispatch = useDispatch()

  const fetchifthenData = async () => {
    setLoad(true)
    const result = await apiClient.get("/if-then?populate=true&limit=100000000")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (getName(a.itemId) < getName(b.itemId)) return -1
      if (getName(a.itemId) > getName(b.itemId)) return 1
      return 0
    })
    setIfthenData(sorted)
    setIfFilterData(sorted)
    setLoad(false)
  }

  const removeIfThen = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchifthenData()
  }

  const filterIfThen = value => {
    const filteredData = ifFilterData.filter(item =>
      [item.itemId, ...(item.items || [])].some(field => textIncludes(field, value))
    )
    setIfthenData(filteredData)
  }

  useEffect(() => {
    fetchifthenData()
  }, [])

  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">If-Then Items</Typography>
        <Grid container>
          <Grid item xs={6} className="p-3 d-flex">
            <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}>
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search"
                inputProps={{ "aria-label": "search" }}
                onKeyUp={e => e.key === "Enter" && filterIfThen(search)}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon onClick={() => filterIfThen(search)} />
              </IconButton>
            </Paper>
          </Grid>
          <Grid item xs={6} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              onClick={() => {
                setItemDataEdit(false)
                setIfthenModal(true)
              }}>
              Add Item
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                "itemId.name": "If Item",
                ifthen: "If-Then",
                actions: "Action"
              }}
              td={ifthenData}
              customFields={[
                {
                  name: "itemId.name",
                  data: (value, item) => getName(item.itemId)
                },
                {
                  name: "ifthen",
                  data: (value, item) => joinNames(item.items)
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setIfthenModal(true)
                          setIfthenEdit(item)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeIfThen(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {ifthenModal && (
        <IfThen
          fetchifthenData={fetchifthenData}
          ifthenEdit={ifthenEdit}
          show={ifthenModal}
          itemData={itemData}
          onHide={() => {
            setIfthenModal(false)
            setIfthenEdit(null)
          }}
        />
      )}
    </>
  )
}

// IfThenIntolPetSection Component
const IfThenIntolPetSection = ({ itemData, setLoad }) => {
  const [ifthenIntolPet, setIfthenIntolPet] = useState([])
  const [ifthenIntolPetEdit, setIfthenIntolPetEdit] = useState(null)
  const [ifthenIntolPetModal, setIfthenIntolPetModal] = useState(false)
  const dispatch = useDispatch()

  const fetchifthenIntolPet = async () => {
    setLoad(true)
    const result = await apiClient.get("/if-then/pet-intolerance/?populate=true&limit=100000000")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (!a.itemId && !b.itemId) return 0
      if (!a.itemId) return 1
      if (!b.itemId) return -1
      if (getName(a.itemId) < getName(b.itemId)) return -1
      if (getName(a.itemId) > getName(b.itemId)) return 1
      return 0
    })
    setIfthenIntolPet(sorted)
    setLoad(false)
  }

  const removeIfThenIntolRef = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/pet-intolerance/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchifthenIntolPet()
  }

  useEffect(() => {
    fetchifthenIntolPet()
  }, [])

  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">If-Then Intolerance Pet Based</Typography>
        <Grid container>
          <Grid item xs={12} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              style={{ paddingTop: 12, paddingBottom: 12 }}
              onClick={() => setIfthenIntolPetModal(true)}>
              Add Product
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                itemName: "Item Name",
                item_senstivity: "Sensitivity",
                pet_type: "Pet Type",
                actions: "Action"
              }}
              td={ifthenIntolPet.filter(x => x.itemId)}
              customFields={[
                {
                  name: "itemName",
                  data: (value, item) => getName(item.itemId)
                },
                {
                  name: "item_senstivity",
                  data: (value, item) =>
                    value === "HG" ? (
                      <Chip label="High" style={{ backgroundColor: "Red", color: "white" }} />
                    ) : (
                      value === "MD" && (
                        <Chip
                          label="Medium"
                          style={{ backgroundColor: "yellow", color: "black" }}
                        />
                      )
                    )
                },
                {
                  name: "pet_type",
                  data: (value, item) => value?.toUpperCase() || "All"
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setIfthenIntolPetEdit(item)
                          setIfthenIntolPetModal(true)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeIfThenIntolRef(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {ifthenIntolPetModal && (
        <IfThenIntolPetBased
          fetchifthenData={fetchifthenIntolPet}
          ifthenEdit={ifthenIntolPetEdit}
          itemData={itemData}
          show={ifthenIntolPetModal}
          onHide={() => {
            setIfthenIntolPetModal(false)
            setIfthenIntolPetEdit(null)
          }}
        />
      )}
    </>
  )
}

// IfThenProductsSection Component
const IfThenProductsSection = ({ itemData, productData, setLoad }) => {
  const [ifthenProductData, setIfthenProductData] = useState([])
  const [ifProductFilterData, setIfProductFilterData] = useState([])
  const [ifthenProductEdit, setIfthenProductEdit] = useState(null)
  const [ifthenProductModal, setIfthenProductModal] = useState(false)
  const dispatch = useDispatch()

  const fetchifthenProductData = async () => {
    setLoad(true)
    const result = await apiClient.get("/if-then/products/?populate=true&limit=100000000")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (!a.itemId && !b.itemId) return 0
      if (!a.itemId) return 1
      if (!b.itemId) return -1
      if (getName(a.itemId) < getName(b.itemId)) return -1
      if (getName(a.itemId) > getName(b.itemId)) return 1
      return 0
    })
    setIfthenProductData(sorted)
    setIfProductFilterData(sorted)
    setLoad(false)
  }

  const removeIfThenProduct = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/products/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchifthenProductData()
  }

  useEffect(() => {
    fetchifthenProductData()
  }, [])

  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">If-Then Products</Typography>
        <Grid container>
          <Grid item xs={12} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              style={{ paddingTop: 12, paddingBottom: 12 }}
              onClick={() => setIfthenProductModal(true)}>
              Add Product
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                itemName: "Item Name",
                item_senstivity: "Sensitivity",
                "product.name": "Product",
                product_recommended: "Product Recommended",
                pet_type: "Pet Type",
                actions: "Action"
              }}
              td={ifthenProductData.filter(x => x.itemId)}
              customFields={[
                {
                  name: "itemName",
                  data: (value, item) => getName(item.itemId)
                },
                {
                  name: "product_recommended",
                  data: (value, item) =>
                    value ? (
                      <Chip
                        label="Recommended"
                        style={{ backgroundColor: "green", color: "white" }}
                      />
                    ) : (
                      <Chip
                        label="Not-Recommended"
                        style={{ backgroundColor: "red", color: "white" }}
                      />
                    )
                },
                {
                  name: "item_senstivity",
                  data: (value, item) =>
                    value === "HG" ? (
                      <Chip label="High" style={{ backgroundColor: "Red", color: "white" }} />
                    ) : (
                      value === "MD" && (
                        <Chip
                          label="Medium"
                          style={{ backgroundColor: "yellow", color: "black" }}
                        />
                      )
                    )
                },
                {
                  name: "pet_type",
                  data: (value, item) => value?.toUpperCase() || "All"
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setIfthenProductEdit(item)
                          setIfthenProductModal(true)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeIfThenProduct(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {ifthenProductModal && (
        <IfThenProduct
          fetchifthenData={fetchifthenProductData}
          ifthenEdit={ifthenProductEdit}
          productData={productData}
          itemData={itemData}
          show={ifthenProductModal}
          onHide={() => {
            setIfthenProductModal(false)
            setIfthenProductEdit(null)
          }}
        />
      )}
    </>
  )
}

// IfThenPetTypeProductsSection Component
const IfThenPetTypeProductsSection = ({ itemData, productData, setLoad }) => {
  const [ifthenProductData, setIfthenProductData] = useState([])
  const [ifthenProductPetEdit, setIfthenProductPetEdit] = useState(null)
  const [ifthenProductPetModal, setIfthenProductPetModal] = useState(false)
  const dispatch = useDispatch()

  const fetchifthenProductData = async () => {
    setLoad(true)
    const result = await apiClient.get("/if-then/products/?populate=true&limit=100000000")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (!a.itemId && !b.itemId) return 0
      if (!a.itemId) return 1
      if (!b.itemId) return -1
      if (getName(a.itemId) < getName(b.itemId)) return -1
      if (getName(a.itemId) > getName(b.itemId)) return 1
      return 0
    })
    setIfthenProductData(sorted)
    setLoad(false)
  }

  const removeIfThenProduct = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/products/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchifthenProductData()
  }

  useEffect(() => {
    fetchifthenProductData()
  }, [])

  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">If-Then Pet Type Products</Typography>
        <Grid container>
          <Grid item xs={12} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              style={{ paddingTop: 12, paddingBottom: 12 }}
              onClick={() => setIfthenProductPetModal(true)}>
              Add Pet Based Product
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                pet_type: "Pet Type",
                "product.name": "Product",
                product_recommended: "Product Recommended",
                actions: "Action"
              }}
              td={ifthenProductData.filter(x => !x.itemId)}
              customFields={[
                {
                  name: "product_recommended",
                  data: (value, item) =>
                    value ? (
                      <Chip
                        label="Recommended"
                        style={{ backgroundColor: "green", color: "white" }}
                      />
                    ) : (
                      <Chip
                        label="Not-Recommended"
                        style={{ backgroundColor: "red", color: "white" }}
                      />
                    )
                },
                {
                  name: "pet_type",
                  data: (value, item) => value?.toUpperCase() || "All"
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setIfthenProductPetEdit(item)
                          setIfthenProductPetModal(true)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeIfThenProduct(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {ifthenProductPetModal && (
        <IfThenProductByPet
          fetchifthenData={fetchifthenProductData}
          ifthenEdit={ifthenProductPetEdit}
          productData={productData}
          itemData={itemData}
          show={ifthenProductPetModal}
          onHide={() => {
            setIfthenProductPetModal(false)
            setIfthenProductPetEdit(null)
          }}
        />
      )}
    </>
  )
}

// EnergeticImbalanceSection Component
const EnergeticImbalanceSection = ({ productData, setLoad }) => {
  const [engRefProductData, setEngRefProductData] = useState([])
  const [engRefProductFilterData, setEngRefProductFilterData] = useState([])
  const [engRefProductEdit, setEngRefProductEdit] = useState(null)
  const [engRefProductModal, setEngRefProductModal] = useState(false)
  const dispatch = useDispatch()

  const fetchEnerRefProductData = async () => {
    setLoad(true)
    const result = await apiClient.get("/if-then/energetic/?populate=true&limit=100000000")
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (a.energetic_imbalance < b.energetic_imbalance) return -1
      if (a.energetic_imbalance > b.energetic_imbalance) return 1
      return 0
    })
    setEngRefProductData(sorted)
    setEngRefProductFilterData(sorted)
    setLoad(false)
  }

  const removeEnerRefProduct = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/energetic/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchEnerRefProductData()
  }

  useEffect(() => {
    fetchEnerRefProductData()
  }, [])

  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">Energetic Imbalance If-Then Products</Typography>
        <Grid container>
          <Grid item xs={12} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              style={{ paddingTop: 12, paddingBottom: 12 }}
              onClick={() => setEngRefProductModal(true)}>
              Add
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                energetic_imbalance: "Energetic Item",
                "product.name": "Product",
                product_recommended: "Product Recommended",
                pet_type: "Pet Type",
                actions: "Action"
              }}
              td={engRefProductData}
              customFields={[
                {
                  name: "product_recommended",
                  data: (value, item) =>
                    value ? (
                      <Chip
                        label="Recommended"
                        style={{ backgroundColor: "green", color: "white" }}
                      />
                    ) : (
                      <Chip
                        label="Not-Recommended"
                        style={{ backgroundColor: "red", color: "white" }}
                      />
                    )
                },
                {
                  name: "pet_type",
                  data: (value, item) => value?.toUpperCase() || "All"
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setEngRefProductEdit(item)
                          setEngRefProductModal(true)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeEnerRefProduct(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {engRefProductModal && (
        <EngRefProductModalComp
          fetchifthenData={fetchEnerRefProductData}
          ifthenEdit={engRefProductEdit}
          productData={productData}
          show={engRefProductModal}
          onHide={() => {
            setEngRefProductModal(false)
            setEngRefProductEdit(null)
          }}
        />
      )}
    </>
  )
}
// EnergeticImbalanceRefIntol Component
const EnergeticImbalanceRefIntolSection = ({ itemData, setLoad }) => {
  const [ifthenData, setIfthenData] = useState([])
  const [ifFilterData, setIfFilterData] = useState([])
  const [search, setSearch] = useState("")
  const [ifthenEdit, setIfthenEdit] = useState(null)
  const [ifthenModal, setIfthenModal] = useState(false)
  const [itemDataEdit, setItemDataEdit] = useState(false)
  const dispatch = useDispatch()

  const fetchifthenData = async () => {
    setLoad(true)
    const result = await apiClient.get(
      "/if-then/energetic-intolerance?populate=true&limit=100000000"
    )
    if (!result.ok) {
      console.log("error")
      setLoad(false)
      return
    }
    const sorted = result.data.results.sort((a, b) => {
      if (getName(a.itemId) < getName(b.itemId)) return -1
      if (getName(a.itemId) > getName(b.itemId)) return 1
      return 0
    })
    setIfthenData(sorted)
    setIfFilterData(sorted)
    setLoad(false)
  }

  const removeIfThen = async id => {
    setLoad(true)
    const result = await apiClient.delete(`/if-then/energetic-intolerance/${id}`)
    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
      setLoad(false)
      return
    }
    fetchifthenData()
  }

  const filterIfThen = value => {
    const query = (value || "").toLowerCase()
    const filteredData = ifFilterData.filter(item =>
      [
        item.energetic_imbalance,
        ...(item.items || []).map(item => getName(item._id))
      ].some(field => (field || "").toLowerCase().includes(query))
    )
    setIfthenData(filteredData)
  }

  useEffect(() => {
    fetchifthenData()
  }, [])
  const getDisplayText = itemsList => {
    if (!itemsList || itemsList.length === 0) return ""
    return itemsList
      .map(({ _id, senstivity }) => {
        const name = getName(_id)
        return name ? `${name} (${senstivity})` : ""
      })
      .filter(Boolean)
      .join(", ")
  }
  return (
    <>
      <Box className="mt-5">
        <Typography variant="h6">If-Then Energetic Imbalances</Typography>
        <Grid container>
          <Grid item xs={6} className="p-3 d-flex">
            <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}>
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search"
                inputProps={{ "aria-label": "search" }}
                onKeyUp={e => e.key === "Enter" && filterIfThen(search)}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon onClick={() => filterIfThen(search)} />
              </IconButton>
            </Paper>
          </Grid>
          <Grid item xs={6} className="p-3 d-flex justify-content-end">
            <Button
              className="btn btn_bg_ter"
              variant="contained"
              onClick={() => {
                setItemDataEdit(false)
                setIfthenModal(true)
              }}>
              Add Item
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableMui
              styleTableContainer={{ height: "70vh" }}
              styleTableTh={{
                color: "white",
                backgroundColor: "#3E4755",
                fontWeight: "bold",
                whiteSpace: "nowrap"
              }}
              th={{
                energetic_imbalance: "Energetic imbalance",
                ifthen: "If-Then",
                actions: "Action"
              }}
              td={ifthenData}
              customFields={[
                {
                  name: "ifthen",
                  data: (value, item) => getDisplayText(item.items)
                },
                {
                  name: "actions",
                  data: (value, item) => (
                    <Box className="d-flex gap-3">
                      <ReportSettingsAction
                        title="Edit"
                        type="edit"
                        onClick={() => {
                          setIfthenModal(true)
                          setIfthenEdit(item)
                        }}
                      />
                      <ReportSettingsAction
                        title="Delete"
                        type="delete"
                        onClick={() => removeIfThen(item._id)}
                      />
                    </Box>
                  )
                }
              ]}
            />
          </Grid>
        </Grid>
      </Box>
      {ifthenModal && (
        <EnergeticImbalanceRefIntolModal
          fetchifthenData={fetchifthenData}
          ifthenEdit={ifthenEdit}
          show={ifthenModal}
          itemData={itemData}
          onHide={() => {
            setIfthenModal(false)
            setIfthenEdit(null)
          }}
        />
      )}
    </>
  )
}

// Product Tab Component
const ProductTab = () => {
  const [productData, setProductData] = useState()
  const [search, setSearch] = useState()
  const [productEdit, setProductEdit] = useState()
  const [product, setProduct] = useState(false)
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch()
  const fetchproduct = async () => {
    setLoad(true)
    const result = await apiClient.get("/report/product")
    if (!result.ok) return console.log("error")
    setProductData(result.data.results)
    setLoad(false)
  }

  const removeProduct = async id => {
    const result = await apiClient.delete(`/report/product/${id}`)
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    fetchproduct()
  }

  useEffect(() => {
    fetchproduct()
  }, [])

  return (
    <>
      <Products />
      <Grid container>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search"
              inputProps={{ "aria-label": "search " }}
            />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
        <Grid item xs={6} className="p-3 d-flex justify-content-end">
          <Button
            className="btn btn_bg_ter"
            variant="contained"
            onClick={() => {
              setProduct(true)
            }}>
            Add Item
          </Button>
        </Grid>
        {!load ? (
          <TableMui
            styleTableContainer={{ height: "70vh" }}
            styleTableTh={{
              color: "white",
              backgroundColor: "#3E4755",
              fontWeight: "bold",
              whiteSpace: "nowrap"
            }}
            th={{
              name: "Name",
              link: "Link",
              description: "Description",
              image: "Image",
              actions: "Action"
            }}
            td={productData}
            customFields={[
              {
                name: "actions",
                data: (value, item) => (
                  <Box className="d-flex gap-3">
                    <ReportSettingsAction
                      title="Edit"
                      type="edit"
                      onClick={() => {
                        setProductEdit(item)
                        setProduct(true)
                      }}
                    />
                    <ReportSettingsAction
                      title="Delete"
                      type="delete"
                      onClick={() => removeProduct(item._id)}
                    />
                  </Box>
                )
              },
              {
                name: "link",
                data: (value, item) => item.link.substring(0, 20) + "..."
              },
              {
                name: "image",
                data: (value, item) => (
                  <img src={item.image} alt="Product Image" width="50" height="50" />
                )
              },
              {
                name: "description",
                data: (value, item) => item.description.substring(0, 20) + "..."
              }
            ]}
          />
        ) : (
          <div className="w-100 d-flex justify-content-center slign-items-center">
            <CircularProgress />
          </div>
        )}
      </Grid>

      {product && (
        <Products
          fetchproduct={fetchproduct}
          productEdit={productEdit}
          show={product}
          onHide={() => {
            setProduct(false)
            setProductEdit(null)
          }}
        />
      )}
    </>
  )
}

// Modals for each section

function Category(props) {
  // console.log(props.categoryEdit,"nml");
  const [categoryName, setCategoryName] = useState(
    props.categoryEdit ? props.categoryEdit.name : ""
  )
  const dispatch = useDispatch()
  const handleSubmit = async e => {
    e.preventDefault()
    let result
    if (props.categoryEdit) {
      result = await apiClient.put(`/report/category/${props.categoryEdit._id}`, {
        name: categoryName
      })
    } else {
      result = await apiClient.post("/report/category/", { name: categoryName })
    }
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    props.onHide()
    props.fetchData()
  }
  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container className=" d-flex justify-content-center align-items-center">
            <Grid item xs={8} spacing={3} className="d-flex gap-4">
              <TextField
                id="outlined-basic"
                value={categoryName}
                label="Category"
                fullWidth
                variant="outlined"
                onChange={e => setCategoryName(e.target.value)}
              />
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {props.categoryEdit ? "Edit" : "Add"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}

function Item(props) {
  let initialState = {
    category: props.itemDataEdit ? props.itemDataEdit.category._id : "",
    name: props.itemDataEdit ? props.itemDataEdit.name : ""
  }
  const [itemAdd, setItemAdd] = useState(initialState)
  const dispatch = useDispatch()
  const handleChange = (key, value) => {
    setItemAdd({ ...itemAdd, [key]: value })
  }
  const handleSubmit = async e => {
    e.preventDefault()
    let result
    if (props.itemDataEdit) {
      result = await apiClient.put(`/report/item/${props.itemDataEdit._id}`, itemAdd)
    } else {
      result = await apiClient.post("/report/item/", itemAdd)
    }
    if (!result.ok)
      return dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    props.fetchItemData()
    props.onHide()
    // console.log(itemAdd);
  }
  // console.log(props.itemDataEdit,"hhhhhhh");
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  selected={itemAdd.category}
                  value={itemAdd.category}
                  label="Category"
                  onChange={e => handleChange("category", e.target.value)}>
                  {props.categoryData.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <TextField
                id="outlined-basic"
                label="Item"
                value={itemAdd.name}
                onChange={e => handleChange("name", e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                Add
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}

//if then modals

function IfThen(props) {
  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    // category:props.itemDataEdit?props.itemDataEdit.category._id:"",
    // name:props.itemDataEdit?props.itemDataEdit.name:"",
    itemId: "",
    items: []
  }
  const [IfthenitemAdd, setIfthenItemAdd] = useState(props?.ifthenEdit?.items || [])
  const [IfthenitemAdd2, setIfthenItemAdd2] = useState(props?.ifthenEdit?.itemId?._id || "")

  const handleChange2 = e => {
    setIfthenItemAdd2(e.target.value)
  }
  const handleChange = (key, value) => {
    setIfthenItemAdd(value)
  }

  const [ifthenname, setIfthenname] = useState(props.categoryEdit ? props.categoryEdit.name : "")
  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()
    // console.log(IfthenitemAdd.map(item=>item._id),"lkio");
    // console.log(IfthenitemAdd2,"lkio2");
    let result

    if (props.ifthenEdit) {
      result = await apiClient.put(`/if-then/${props.ifthenEdit._id}`, {
        itemId: IfthenitemAdd2,
        items: IfthenitemAdd.map(item => item._id)
      })
    } else {
      result = await apiClient.post("/if-then/", {
        itemId: IfthenitemAdd2,
        items: IfthenitemAdd.map(item => item._id)
      })
    }

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    props.onHide()
    props.fetchifthenData()
  }

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">If-Items</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={IfthenitemAdd2}
                  onChange={handleChange2}
                  label="Category">
                  {props.itemData.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={props.itemData}
                disableCloseOnSelect
                onChange={handleChange}
                value={IfthenitemAdd}
                getOptionLabel={option => option.name}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                renderOption={(props, option, { selected }) => {
                  return (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  )
                }}
                renderInput={params => (
                  <TextField {...params} label="Then-Items" placeholder="items" />
                )}
              />
            </Grid>
            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}
function IfThenIntolPetBased({ fetchifthenData, ifthenEdit, itemData, show, onHide }) {
  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    itemId: ifthenEdit?.itemId?._id || "",
    item_senstivity: ifthenEdit?.item_senstivity || "",
    pet_type: ifthenEdit?.pet_type || ""
  }
  const [formData, setFormData] = useState(initialState)

  const handleChange = (key, value) => {
    setFormData(prev => {
      return { ...prev, [key]: value }
    })
  }

  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()

    let formDataObj = { ...formData }

    if (!formDataObj.itemId) delete formDataObj.itemId
    const endpoint = ifthenEdit
      ? `/if-then/pet-intolerance/${ifthenEdit._id}`
      : "/if-then/pet-intolerance/"
    const method = ifthenEdit ? "put" : "post"

    const result = await apiClient[method](endpoint, formDataObj)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    onHide()
    fetchifthenData()
  }
  const petTypesArr = [
    { name: "All", value: "" },
    { name: "Dog", value: "dog" },
    { name: "Cat", value: "cat" },
    { name: "Equine", value: "equine" }
  ]
  const itemSenstivityArr = [
    { name: "High", value: "HG" },
    { name: "Medium", value: "MD" }
  ]
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel shrink id="demo-simple-select-label">
                  For Pet Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  displayEmpty
                  value={formData.pet_type}
                  onChange={e => handleChange("pet_type", e.target.value)}
                  label="For Pet Type"
                  input={<OutlinedInput notched label="For Pet Type" />}>
                  {petTypesArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Intolerance Item</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.itemId}
                  onChange={e => handleChange("itemId", e.target.value)}
                  label="Intolerance Item">
                  {itemData.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Intolerance Sensitivity</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.item_senstivity}
                  onChange={e => handleChange("item_senstivity", e.target.value)}
                  label="Intolerance Sensitivity">
                  {itemSenstivityArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}
function IfThenProduct({ fetchifthenData, ifthenEdit, productData, itemData, show, onHide }) {
  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    itemId: ifthenEdit?.itemId?._id || "",
    item_senstivity: ifthenEdit?.item_senstivity || "",
    product: ifthenEdit?.product._id || "",
    product_recommended: ifthenEdit?.product_recommended || false,
    pet_type: ifthenEdit?.pet_type || ""
  }
  const [formData, setFormData] = useState(initialState)

  const handleChange = (key, value) => {
    setFormData(prev => {
      return { ...prev, [key]: value }
    })
  }

  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()

    let formDataObj = { ...formData }

    if (!formDataObj.itemId) delete formDataObj.itemId
    const endpoint = ifthenEdit ? `/if-then/products/${ifthenEdit._id}` : "/if-then/products/"
    const method = ifthenEdit ? "put" : "post"

    const result = await apiClient[method](endpoint, formDataObj)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    onHide()
    fetchifthenData()
  }
  const petTypesArr = [
    { name: "All", value: "" },
    { name: "Dog", value: "dog" },
    { name: "Cat", value: "cat" },
    { name: "Equine", value: "equine" }
  ]
  const itemSenstivityArr = [
    { name: "High", value: "HG" },
    { name: "Medium", value: "MD" }
  ]
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Intolerance Item</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.itemId}
                  onChange={e => handleChange("itemId", e.target.value)}
                  label="Intolerance Item">
                  {itemData?.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Intolerance Sensitivity</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.item_senstivity}
                  onChange={e => handleChange("item_senstivity", e.target.value)}
                  label="Intolerance Sensitivity">
                  {itemSenstivityArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Product</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.product}
                  onChange={e => handleChange("product", e.target.value)}
                  label="Product">
                  {productData?.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel shrink id="demo-simple-select-label">
                  For Pet Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  displayEmpty
                  value={formData.pet_type}
                  onChange={e => handleChange("pet_type", e.target.value)}
                  label="For Pet Type"
                  input={<OutlinedInput notched label="For Pet Type" />}>
                  {petTypesArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Product Recommendation
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={formData.product_recommended}
                  onChange={e => handleChange("product_recommended", e.target.value)}>
                  <FormControlLabel value={true} control={<Radio />} label="Recommended" />
                  <FormControlLabel value={false} control={<Radio />} label="Not Recommmended" />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}

function IfThenProductByPet({ fetchifthenData, ifthenEdit, productData, itemData, show, onHide }) {
  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    product: ifthenEdit?.product._id || "",
    product_recommended: ifthenEdit?.product_recommended || false,
    pet_type: ifthenEdit?.pet_type || ""
  }
  const [formData, setFormData] = useState(initialState)

  const handleChange = (key, value) => {
    setFormData(prev => {
      return { ...prev, [key]: value }
    })
  }

  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()

    let formDataObj = { ...formData }

    if (!formDataObj.itemId) delete formDataObj.itemId
    const endpoint = ifthenEdit ? `/if-then/products/${ifthenEdit._id}` : "/if-then/products/"
    const method = ifthenEdit ? "put" : "post"

    const result = await apiClient[method](endpoint, formDataObj)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    onHide()
    fetchifthenData()
  }
  const petTypesArr = [
    { name: "All", value: "" },
    { name: "Dog", value: "dog" },
    { name: "Cat", value: "cat" },
    { name: "Equine", value: "equine" }
  ]

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Product</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.product}
                  onChange={e => handleChange("product", e.target.value)}
                  label="Product">
                  {productData?.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel shrink id="demo-simple-select-label">
                  For Pet Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  displayEmpty
                  value={formData.pet_type}
                  onChange={e => handleChange("pet_type", e.target.value)}
                  label="For Pet Type"
                  input={<OutlinedInput notched label="For Pet Type" />}>
                  {petTypesArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Product Recommendation
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={formData.product_recommended}
                  onChange={e => handleChange("product_recommended", e.target.value)}>
                  <FormControlLabel value={true} control={<Radio />} label="Recommended" />
                  <FormControlLabel value={false} control={<Radio />} label="Not Recommmended" />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}
function EngRefProductModalComp({ fetchifthenData, ifthenEdit, productData, show, onHide }) {
  const energeticData = [
    "Bacteria",
    "Chlorine",
    "Fungus",
    "Chloride",
    "Pesticide",
    "Inflammation",
    "Mold",
    "Pain",
    "Parasites",
    "Virus",
    "Yeast",
    "Candida",
    "Herbicides",
    "Emotions",
    "Vaccinosis",
    "Thyroid"
  ]

  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    energetic_imbalance: ifthenEdit?.energetic_imbalance || "",
    product: ifthenEdit?.product._id || "",
    product_recommended: ifthenEdit?.product_recommended || false,
    pet_type: ifthenEdit?.pet_type || ""
  }
  const [formData, setFormData] = useState(initialState)

  const handleChange = (key, value) => {
    setFormData(prev => {
      return { ...prev, [key]: value }
    })
  }

  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()
    const endpoint = ifthenEdit ? `/if-then/energetic/${ifthenEdit._id}` : "/if-then/energetic/"
    const method = ifthenEdit ? "put" : "post"

    const result = await apiClient[method](endpoint, formData)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    onHide()
    fetchifthenData()
  }
  const petTypesArr = [
    { name: "All", value: "" },
    { name: "Dog", value: "dog" },
    { name: "Cat", value: "cat" },
    { name: "Equine", value: "equine" }
  ]
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Energetic Item</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.energetic_imbalance}
                  onChange={e => handleChange("energetic_imbalance", e.target.value)}
                  label="Intolerance Item">
                  {energeticData.map(item => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Product</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.product}
                  onChange={e => handleChange("product", e.target.value)}
                  label="Product">
                  {productData.map(item => (
                    <MenuItem value={item._id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel shrink id="demo-simple-select-label">
                  For Pet Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  displayEmpty
                  value={formData.pet_type}
                  onChange={e => handleChange("pet_type", e.target.value)}
                  label="For Pet Type"
                  input={<OutlinedInput notched label="For Pet Type" />}>
                  {petTypesArr.map(item => (
                    <MenuItem value={item.value}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Product Recommendation
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={formData.product_recommended}
                  onChange={e => handleChange("product_recommended", e.target.value)}>
                  <FormControlLabel value={true} control={<Radio />} label="Recommended" />
                  <FormControlLabel value={false} control={<Radio />} label="Not Recommmended" />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}
function EnergeticImbalanceRefIntolModal({ fetchifthenData, ifthenEdit, itemData, show, onHide }) {
  // console.log(props.ifthenEdit, "nml");

  const energeticData = [
    "Bacteria",
    "Chlorine",
    "Fungus",
    "Chloride",
    "Pesticide",
    "Inflammation",
    "Mold",
    "Pain",
    "Parasites",
    "Virus",
    "Yeast",
    "Candida",
    "Herbicides",
    "Emotions",
    "Vaccinosis",
    "Thyroid"
  ]

  // console.log(props.ifthenEdit, "nml");
  let initialState = {
    energetic_imbalance: ifthenEdit?.energetic_imbalance || "",
    items: ifthenEdit?.items._id || []
  }
  const [selectedItems, setSelectedItems] = useState(
    ifthenEdit?.items.length > 0
      ? ifthenEdit?.items.map(item => ({ ...item, _id: item._id._id }))
      : []
  )
  const [formData, setFormData] = useState(initialState)

  const handleChange = (key, value) => {
    setFormData(prev => {
      return { ...prev, [key]: value }
    })
  }

  const dispatch = useDispatch()

  const handleSubmit = async e => {
    const FormDataObj = {
      ...formData,
      items: selectedItems
    }
    e.preventDefault()
    const endpoint = ifthenEdit
      ? `/if-then/energetic-intolerance/${ifthenEdit._id}`
      : "/if-then/energetic-intolerance/"
    const method = ifthenEdit ? "put" : "post"

    const result = await apiClient[method](endpoint, FormDataObj)

    if (!result.ok) {
      dispatch(
        showModal({
          error: true,
          title: "Client",
          message: result.data.message
        })
      )
    }

    onHide()
    fetchifthenData()
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">If-Then</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} className="d-flex justify-content-center align-items-center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Energetic imbalance</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formData.energetic_imbalance}
                  onChange={e => handleChange("energetic_imbalance", e.target.value)}
                  label="Energetic imbalance">
                  {energeticData.map(item => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={itemData}
                disableCloseOnSelect
                onChange={(key, value) => handleChange("items", value)}
                value={formData.items}
                getOptionLabel={option => option.name}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                renderOption={(props, option, { selected }) => {
                  return (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  )
                }}
                renderInput={params => (
                  <TextField {...params} label="Then-Items" placeholder="items" />
                )}
              />
            </Grid> */}
            <Grid item xs={12} md={6}>
              <HighLowSelect
                items={itemData}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
              />
            </Grid>
            <Grid item xs={12} mt={5} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {" "}
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}

//products modal
function Products(props) {
  // console.log(props.productEdit," product edit data")
  let initialState = {
    name: props.productEdit?.name || "",
    link: props.productEdit?.link || "",
    description: props.productEdit?.description || "",
    image: props.productEdit?.image || ""
  }

  const [productAdd, setproductAdd] = useState(initialState)
  const dispatch = useDispatch()
  const handleChange = (key, value) => {
    setproductAdd({ ...productAdd, [key]: value })
  }
  const handleSubmit = async e => {
    e.preventDefault()
    const formData = new FormData()
    formData.append("name", productAdd.name)
    formData.append("link", productAdd.link)
    formData.append("description", productAdd.description)
    formData.append("image", productAdd.image)

    let result

    if (props.productEdit) {
      result = await apiClient.put(`/report/product/${props.productEdit._id}`, formData)
    } else {
      result = await apiClient.post("/report/product", formData)
    }

    if (!result.ok) {
      toast.error("Error adding product")
    } else {
      toast.success("Product added successfully")
    }
    props.fetchproduct()

    // console.log(result, "product result")
    props.onHide()
    // console.log(productAdd);
  }
  // console.log(props.itemDataEdit,"hhhhhhh");
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <TextField
                id="outlined-basic"
                label="GPH Product"
                value={productAdd?.name}
                onChange={e => handleChange("name", e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <TextField
                id="outlined-basic"
                label="Link to Product page"
                value={productAdd.link}
                onChange={e => handleChange("link", e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <TextField
                id="outlined-basic"
                multiline
                label="Discription"
                value={productAdd.description}
                onChange={e => handleChange("description", e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6} spacing={3} className="d-flex ">
              <input
                onChange={e => handleChange("image", e.target.files[0])}
                type="file"
                name=""
                id=""
              />
              {/* <TextField id="outlined-basic" label="Discription" value={productAdd.description} onChange={(e)=>handleChange("description",e.target.value)} fullWidth variant="outlined"  /> */}
            </Grid>
            <Grid item xs={12} className="d-flex justify-content-center">
              <Button type="submit" className="btn btn_bg_ter" variant="contained">
                {props.productEdit ? "Update" : "Add"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  )
}
